"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _styledComponents = _interopRequireWildcard(require("styled-components"));

var _Radio = _interopRequireDefault(require("../Radio"));

var _ScreenReaderOnly = _interopRequireDefault(require("../ScreenReaderOnly"));

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _templateObject10() {
  var data = _taggedTemplateLiteral(["\n  display: block;\n  padding: ", ";\n"]);

  _templateObject10 = function _templateObject10() {
    return data;
  };

  return data;
}

function _templateObject9() {
  var data = _taggedTemplateLiteral(["\n  display: block;\n  box-sizing: border-box;\n  width: 100%;\n  margin: 0;\n  padding: 6px;\n  cursor: ", ";\n"]);

  _templateObject9 = function _templateObject9() {
    return data;
  };

  return data;
}

function _templateObject8() {
  var data = _taggedTemplateLiteral(["\n  @media print {\n    ", "\n  }\n\n  @media screen and (-ms-high-contrast: active) {\n    background-color: #fff;\n    border-color: #fff;\n    color: #000;\n  }\n\n  @media screen and (-ms-high-contrast: black-on-white) {\n    background-color: #000;\n    border-color: #000;\n    color: #fff;\n  }\n"]);

  _templateObject8 = function _templateObject8() {
    return data;
  };

  return data;
}

function _templateObject7() {
  var data = _taggedTemplateLiteral(["\n  display: inline-block;\n  box-sizing: border-box;\n  width: 9.09092%;\n  height: ", ";\n  background: #fff;\n  font-size: 1.25em;\n  text-align: center;\n  border: 2px solid #dde0e6;\n  border-right: none;\n  margin: 0;\n  padding: 0;\n  padding-top: ", ";\n  transition: all 0.5s ease-out;\n\n  :first-child {\n    border-top-left-radius: 10px;\n    border-bottom-left-radius: 10px;\n  }\n\n  :last-child {\n    border-right: 2px solid #dde0e6;\n    border-top-right-radius: 10px;\n    border-bottom-right-radius: 10px;\n  }\n\n  @media screen and (max-width: 750px) {\n    border-width: 1px;\n    padding: 0;\n    ", "\n\n    :first-child {\n      border-top-left-radius: 5px;\n      border-bottom-left-radius: 5px;\n    }\n\n    :last-child {\n      border-top-right-radius: 5px;\n      border-bottom-right-radius: 5px;\n    }\n  }\n\n  @media print {\n    ", "\n  }\n\n  input[type='radio'] {\n    display: block;\n    margin: 15px auto 5px;\n    padding: 4px 2px 2px 4px;\n  }\n"]);

  _templateObject7 = function _templateObject7() {
    return data;
  };

  return data;
}

function _templateObject6() {
  var data = _taggedTemplateLiteral(["\n  display: inline-block;\n  width: 30%;\n  color: #363942;\n  font-weight: 500;\n  line-height: 1em;\n  font-size: 0.75em;\n\n  @media screen and (max-width: 750px) {\n    width: 35%;\n  }\n"]);

  _templateObject6 = function _templateObject6() {
    return data;
  };

  return data;
}

function _templateObject5() {
  var data = _taggedTemplateLiteral(["\n  text-align: right;\n"]);

  _templateObject5 = function _templateObject5() {
    return data;
  };

  return data;
}

function _templateObject4() {
  var data = _taggedTemplateLiteral(["\n  text-align: left;\n"]);

  _templateObject4 = function _templateObject4() {
    return data;
  };

  return data;
}

function _templateObject3() {
  var data = _taggedTemplateLiteral(["\n  display: table-cell;\n  width: 50%;\n"]);

  _templateObject3 = function _templateObject3() {
    return data;
  };

  return data;
}

function _templateObject2() {
  var data = _taggedTemplateLiteral(["\n  display: table;\n  width: 100%;\n  padding-bottom: 10px;\n"]);

  _templateObject2 = function _templateObject2() {
    return data;
  };

  return data;
}

function _templateObject() {
  var data = _taggedTemplateLiteral(["\n  margin: 10px auto 2em;\n\n  @media screen and (max-width: 750px) {\n    margin-bottom: 1em;\n  }\n\n  .hw-radio-wrapper .hw-radio-image .hw-radio-focus-outline {\n    @media screen and (-ms-high-contrast: active) {\n      stroke: #000;\n    }\n    @media screen and (-ms-high-contrast: black-on-white) {\n      stroke: #fff;\n    }\n  }\n"]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

function _taggedTemplateLiteral(strings, raw) { if (!raw) { raw = strings.slice(0); } return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }

var Root = _styledComponents.default.div(_templateObject());

var LabelsContainer = _styledComponents.default.div(_templateObject2());

var ScaleLabel = _styledComponents.default.span(_templateObject3());

var LeftScaleLabel = (0, _styledComponents.default)(ScaleLabel)(_templateObject4());
var RightScaleLabel = (0, _styledComponents.default)(ScaleLabel)(_templateObject5());

var ScaleLabelText = _styledComponents.default.span(_templateObject6());

var ButtonDefault = _styledComponents.default.div(_templateObject7(), function (props) {
  return props.readonly ? '74px' : props.forPrint ? '80px' : 'auto';
}, function (props) {
  return props.readonly ? '27px' : props.forPrint ? '16px' : '0';
}, function (props) {
  return props.readonly ? "\n      padding-top: 0;\n      height: inherit;\n      line-height: 2em;\n    " : '';
}, function (props) {
  return props.readonly ? "\n      padding: 0.25em;\n      border-color: #eee;\n      height: auto;\n      width: 9.09092%;\n      font-weight: normal;\n      color: #9e9e9e;\n    " : '';
});

var ButtonActive = (0, _styledComponents.default)(ButtonDefault)(_templateObject8(), function (props) {
  return props.readonly ? "\n      font-weight: bold;\n      border-color: rgba(1, 122, 203, 1);\n      border-right: 2px solid rgba(1, 122, 203, 1);\n      border-left-width: 0;\n      background-color: #fff;\n      color: #000;\n    " : '';
});

var ButtonLabel = _styledComponents.default.label(_templateObject9(), function (props) {
  return props.readonly ? 'default' : 'pointer';
});

var ButtonLabelNumber = _styledComponents.default.span(_templateObject10(), function (props) {
  return props.readonly ? '0' : '0.4em 0 0';
});

var LikertScale = /*#__PURE__*/function (_React$Component) {
  _inherits(LikertScale, _React$Component);

  function LikertScale(props) {
    var _this;

    _classCallCheck(this, LikertScale);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(LikertScale).call(this, props));
    _this.handleChange = _this.handleChange.bind(_assertThisInitialized(_this));
    _this.getAxisId = _this.getAxisId.bind(_assertThisInitialized(_this));
    _this.axisBgColors = [];
    _this.axisTextColors = [];
    _this.classNameBase = 'hw_likert_axis_button_'; // set up component state so we can retain the selected value (even if the change doesn't trigger a rerender)

    _this.state = {
      currentValue: _this.props.selectedAnswer
    };

    _this.initStyle();

    return _this;
  }

  _createClass(LikertScale, [{
    key: "UNSAFE_componentWillReceiveProps",
    value: function UNSAFE_componentWillReceiveProps(nextProps) {
      var currentVal = parseInt(this.props.selectedAnswer, 10);
      var newVal = parseInt(nextProps.selectedAnswer, 10);

      if (currentVal !== newVal) {
        this.setState({
          currentValue: newVal
        });
      }
    }
  }, {
    key: "initStyle",
    value: function initStyle() {
      var props = this.props;
      var total = props.maxValue - props.minValue + 1;
      var increment = 1 / total;

      for (var num = 0; num < total; num++) {
        var alpha = increment * num + increment;
        this.axisBgColors[num] = {
          backgroundColor: 'rgba(' + this.props.baseRgbColor + ', ' + alpha + ')'
        };
        this.axisTextColors[num] = {
          color: this.getTextColor(alpha)
        };
      }
    }
  }, {
    key: "getTextColor",
    value: function getTextColor(alpha) {
      var rgbaToRgb = function rgbaToRgb(colors, alpha) {
        return colors.map(function (color) {
          return (1 - alpha) * 255 + alpha * color;
        });
      }; // adapted from http://stackoverflow.com/a/3943023


      var getLuminance = function getLuminance(colors) {
        colors = colors.map(function (c) {
          c = c / 255;
          return c <= 0.03928 ? c / 12.92 : Math.pow((c + 0.055) / 1.055, 2.4);
        });
        return 0.2126 * colors[0] + 0.7152 * colors[1] + 0.0722 * colors[2];
      };

      var bg = this.props.baseRgbColor.split(',');
      var darkText = this.props.darkTextRgbColor.split(',');
      var lightText = this.props.lightTextRgbColor.split(',');
      var toReturn = this.props.darkTextRgbColor; // compare the bg luminance to the dark and light text and pick the best color based on that

      if (bg && darkText && lightText && bg.length === 3 && darkText.length === 3 && lightText.length === 3) {
        var bgColor = rgbaToRgb(bg, alpha);
        var bgLuminance = getLuminance(bgColor);
        var darkLuminance = getLuminance(darkText);
        var lightLuminance = getLuminance(lightText); // TODO (enhancement): we could determine if their contrast ratio is high enough, and if it's not, just send black/white text

        toReturn = (bgLuminance + 0.05) / (darkLuminance + 0.05) > (lightLuminance + 0.05) / (bgLuminance + 0.05) ? this.props.darkTextRgbColor : this.props.lightTextRgbColor;
      }

      return 'rgb(' + toReturn + ')';
    }
  }, {
    key: "handleChange",
    value: function handleChange(e) {
      var el = e.currentTarget;

      if (!this.props.readonly) {
        if (el) {
          var selectedValue = parseInt(el.getAttribute('data-hw-value'), 10); // record the value locally

          this.setState({
            currentValue: selectedValue
          }); // run callback with selected value

          this.props.onAnswer(e, selectedValue, this.props.answerId);
        }
      } else {
        e.preventDefault();
        e.stopPropagation();
      }
    }
  }, {
    key: "getAxisId",
    value: function getAxisId(num) {
      return this.props.id + '_key_' + num;
    }
  }, {
    key: "render",
    value: function render() {
      var selectedAnswer = parseInt(this.state.currentValue, 10);
      var _this$props = this.props,
          id = _this$props.id,
          scaleWrapperId = _this$props.scaleWrapperId,
          name = _this$props.name,
          isRequired = _this$props.isRequired,
          minValue = _this$props.minValue,
          maxValue = _this$props.maxValue,
          minValueText = _this$props.minValueText,
          maxValueText = _this$props.maxValueText,
          readonly = _this$props.readonly,
          forPrint = _this$props.forPrint;
      name = name || id;
      scaleWrapperId = scaleWrapperId || id + '_scale_wrapper';
      var labels = [];
      var width = 100 / (maxValue - minValue + 1) + '%';
      var widthObj = {
        width: width
      };

      for (var i = 0, num = minValue; num <= maxValue; i++, num++) {
        var axisId = this.getAxisId(num);
        var Button = ButtonDefault;
        var radio = null;
        var textColorObj = this.axisTextColors[this.axisTextColors.length - 1];
        var bgColorObj = {
          backgroundColor: 'rgba(' + this.props.baseRgbColor + ', 1)'
        };

        var defaultRadio = _react.default.createElement(_Radio.default, {
          forPrint: forPrint,
          onChange: this.handleChange,
          name: name,
          id: axisId,
          "data-hw-width": num,
          "data-hw-value": num,
          defaultChecked: selectedAnswer === num,
          value: 'hw-likert-button_val_' + num,
          isRequired: isRequired
        });

        if (!readonly) {
          textColorObj = this.axisTextColors[i];
          bgColorObj = this.axisBgColors[i];
          radio = defaultRadio;
        }

        if (forPrint) {
          radio = defaultRadio;
        }

        if (!isNaN(selectedAnswer) && num <= selectedAnswer) {
          // color all the squares to the left of and including the selected answer
          Button = ButtonActive;
        } else {
          bgColorObj = {};
          textColorObj = {
            color: 'rgb(' + this.props.darkTextRgbColor + ')'
          };
        }

        labels.push(_react.default.createElement(Button, {
          id: axisId + '_label',
          key: axisId,
          style: _objectSpread({}, bgColorObj, {}, widthObj),
          readonly: readonly,
          forPrint: forPrint
        }, _react.default.createElement(ButtonLabel, {
          htmlFor: axisId,
          readonly: readonly
        }, _react.default.createElement(ButtonLabelNumber, {
          style: textColorObj,
          readonly: readonly
        }, num), radio)));
      }

      var textValueEquivalent = readonly ? _react.default.createElement(_ScreenReaderOnly.default, null, "".concat(selectedAnswer || 0, " of ").concat(maxValue)) : null;
      return _react.default.createElement(Root, {
        className: "hw-likert-scale",
        id: id,
        "data-hw-likert-min": minValue,
        "data-hw-likert-max": maxValue
      }, _react.default.createElement(LabelsContainer, {
        className: "hw-likert-labels"
      }, _react.default.createElement(LeftScaleLabel, {
        className: "hw-likert-label hw-likert-label-left",
        "aria-hidden": "true"
      }, _react.default.createElement(ScaleLabelText, null, minValueText)), _react.default.createElement(RightScaleLabel, {
        className: "hw-likert-label hw-likert-label-right",
        "aria-hidden": "true"
      }, _react.default.createElement(ScaleLabelText, null, maxValueText))), _react.default.createElement("div", {
        id: scaleWrapperId,
        className: "hw-likert-scale-wrapper"
      }, _react.default.createElement("div", {
        className: "hw-likert-axis",
        "aria-hidden": readonly
      }, labels), textValueEquivalent));
    }
  }]);

  return LikertScale;
}(_react.default.Component);

LikertScale.propTypes = {
  id: _propTypes.default.string.isRequired,
  answerId: _propTypes.default.string,
  isRequired: _propTypes.default.bool,
  selectedAnswer: _propTypes.default.oneOfType([_propTypes.default.number, _propTypes.default.string]),
  minValue: _propTypes.default.oneOfType([_propTypes.default.number, _propTypes.default.string]),
  maxValue: _propTypes.default.oneOfType([_propTypes.default.number, _propTypes.default.string]),
  minValueText: _propTypes.default.string,
  maxValueText: _propTypes.default.string,
  name: _propTypes.default.string,
  scaleWrapperId: _propTypes.default.string,
  baseRgbColor: _propTypes.default.string,
  darkTextRgbColor: _propTypes.default.string,
  lightTextRgbColor: _propTypes.default.string,
  readonly: _propTypes.default.bool,
  forPrint: _propTypes.default.bool,
  onAnswer: _propTypes.default.func
};
LikertScale.defaultProps = {
  isRequired: false,
  minValue: 0,
  maxValue: 10,
  minValueText: 'Not at all important',
  maxValueText: 'Extremely important',
  baseRgbColor: '1, 122, 203',
  darkTextRgbColor: '54, 57, 66',
  lightTextRgbColor: '255, 255, 255',
  readonly: false,
  forPrint: false,
  onAnswer: function onAnswer() {}
};

var _default = (0, _styledComponents.withTheme)(LikertScale);

exports.default = _default;


// WEBPACK FOOTER //
// /src/~/@healthwise-ui/core/LikertScale/index.js